export default function ErrorPage() {
  return (
    <div
      id="error-page"
      className="container flex flex-col items-center justify-center h-5/6"
    >
      <h1 className="text-5xl font-bold">Oh dear!</h1>
      <p className="text-2xl">An unexpected error has occurred.</p>
    </div>
  );
}
